import type { ClipTag } from '@proref/types';
import type { CreateClipTagInput } from '@proref/schemas';
import { api, unwrap, type Envelope } from '../lib/api';

// The managed tag vocabulary for the caller's federation + sport. A referee reads it to build the
// library filter; an admin reads it in the clip editor to pick from. super_admin passes explicit
// federation/sport ids (the console flow), everyone else gets their own scope server-side.
export interface ListClipTagsParams {
  federationId?: string;
  sportId?: string;
}

export async function listClipTags(params: ListClipTagsParams = {}): Promise<ClipTag[]> {
  const query: Record<string, string> = {};
  if (params.federationId) query['federation_id'] = params.federationId;
  if (params.sportId) query['sport_id'] = params.sportId;
  const res = await api.get<Envelope<ClipTag[]>>('/clip-tags', {
    params: Object.keys(query).length > 0 ? query : undefined,
  });
  return unwrap(res.data);
}

// Add a label to the vocabulary (admin only). Returns the created tag.
export async function createClipTag(input: CreateClipTagInput): Promise<ClipTag> {
  const res = await api.post<Envelope<ClipTag>>('/clip-tags', input);
  return unwrap(res.data);
}

// Remove a label from the vocabulary (admin only). Its clip assignments cascade away server-side.
export async function deleteClipTag(id: string): Promise<void> {
  await api.delete(`/clip-tags/${id}`);
}
